require('./preview_controls.js');

Pegasus.LeftPanelView = Em.ContainerView.extend({
  classNames: ['left-panel', 'sidebar'],

  blockLibrary: Em.View, //Pegasus.BuildingBlocksLibraryView,

  previewControls: Pegasus.PreviewControlsView,

  currentView: function(){
    if( this.get('controller.shouldShowPreview') ){
      return this.get('previewControls').create({
        container: this.container
      });
    }
    return this.get('blockLibrary').create({
      container: this.container
    });
  }.property('controller.shouldShowPreview'),

  click: function(){
    if( this.get('controller.isInactive') ){
      Pegasus.stateMachine.send('didFinishEditing', false);
    }
    return false;
  }
});

